import React, { useEffect, useState } from 'react';
import GenericDialog from "../../common/GenericDialog";

const ViewUserProductsDialog = ({ user, visible, handleClose }) => {
    const [userResources, setUserResources] = useState([]);

    useEffect(() => {
        if (user && Array.isArray(user.products)) {
            setUserResources(user.products);
        } else {
            setUserResources([]);
        }
    }, [user]);

    if (!visible) return null;

    return (
        <GenericDialog
            title={`${user?.fullName}'s Products`}
            dialogWidth={400}
            open={visible}
            onClose={() => handleClose(false)}
            buttons={[{ name: 'Close' }]}
        >
            <>
                {userResources.length > 0 ? (
                    <ul>
                        {userResources.map((resource, index) => (
                            <li key={index}>{resource.defaultSyllabusName}</li>
                        ))}
                    </ul>
                ) : (
                    <p>No resources found.</p>
                )}
            </>
        </GenericDialog>
    );
};

export default ViewUserProductsDialog;
